export const triggerMcAfeeOnContextClick = (anchorProps) => {
    // eslint-disable-next-line security/detect-non-literal-fs-filename
    window.open(anchorProps.elementProps.href);
    return false;
};
